import _styled from '@emotion/styled/base';
import { paddingTypes } from './constants.js';
import { border, motion, density } from '@hubble/tokens/web';
import { shorthandSpacingCss } from '../../primitives/Spacer/index.js';

function isInteractive(as) {
  return as === 'a' || as === 'button';
}
const getDensityPadding = density$1 => `
  ${density.content.padding.top[density$1]}
  ${density.content.padding.right[density$1]}
  ${density.content.padding.bottom[density$1]}
  ${density.content.padding.left[density$1]}
`;
const CardWrapper = _styled("div", {
  target: "e1ti15re0"
})(({
  density
}) => `border-radius: ${density === 'sm' ? border.radius.md : border.radius.lg};`, " display:block;overflow:", ({
  overflow
}) => overflow || 'hidden', ";padding:", ({
  padding,
  density
}) => density ? getDensityPadding(density) : paddingTypes[padding], ";position:relative;", ({
  isCollapsible
}) => isCollapsible && `padding-top: ${paddingTypes.none}; padding-bottom: ${paddingTypes.none};`, " ", ({
  customBgColor,
  theme,
  variant
}) => variant === 'outlined' && `
      background-color: ${customBgColor || theme.colorScheme.card.background.outlined.enabled};
      border: 1px solid ${theme.colorScheme.card.border.outlined.enabled};
    `, " ", ({
  customBgColor,
  theme,
  variant
}) => variant === 'filled' && `
      background-color: ${customBgColor || theme.colorScheme.card.background.filled};
      border: 1px solid ${customBgColor || theme.colorScheme.card.border.filled};
    `, " ", ({
  theme,
  variant
}) => variant === 'inverse' && `
      background-color: ${theme.colorScheme.card.background.inverse};
      border: 0;
    `, " ", ({
  as,
  theme
}) => isInteractive(as) && `
      cursor: pointer;
      text-align: left;
      transition: transform ${motion.duration.fast} ${motion.timing.easeInOut},
        background-color ${motion.duration.fast} ${motion.timing.easeInOut},
        border-color ${motion.duration.fast} ${motion.timing.easeInOut};
      width: 100%;

      &:hover,
      &:focus {
        background-color: ${theme.colorScheme.card.background.outlined.hover};
        border-color: ${theme.colorScheme.card.border.outlined.hover};
      }

      &:active {
        transform: scale(0.98);
      }

      &&&[aria-checked="true"] {
        background-color: ${theme.colorScheme.card.background.outlined.selected};
        border-color: ${theme.colorScheme.card.border.outlined.selected};
        box-shadow: inset 0 0 0 1px ${theme.colorScheme.card.border.outlined.selected};
      }
    `, " ", shorthandSpacingCss, ";");

export { CardWrapper };
